import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import type { Post } from "@/types/content";

interface CategoryStripProps {
  posts: Post[];
}

export default function CategoryStrip({ posts }: CategoryStripProps) {
  return (
    <section aria-labelledby="category-strip-title" className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-3 mb-6 md:mb-8">
        <div>
          <p className="text-xs font-medium tracking-widest text-secondary-600 uppercase">按栏目浏览</p>
          <h2 id="category-strip-title" className="mt-2 text-2xl md:text-3xl font-bold text-foreground-950">
            六大线索板块
          </h2>
        </div>
        <p className="text-sm text-foreground-500 max-w-md">
          每条线索都会归入对应板块，方便你按兴趣追踪，而不是被算法推着走。
        </p>
      </div>

      <ul className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
        {categories.map((cat) => {
          const count = posts.filter((p) => p.categorySlug === cat.slug).length;
          return (
            <li key={cat.slug}>
              <Link
                to={`/category/${cat.slug}`}
                className="group flex flex-col h-full p-4 rounded-lg border border-background-200 bg-background-50 hover:border-secondary-300 hover:bg-secondary-50 transition-colors"
              >
                <span className="w-10 h-10 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700 group-hover:bg-secondary-500 group-hover:text-background-50 transition-colors">
                  <i className={`${cat.icon} text-xl`} aria-hidden="true" />
                </span>
                <span className="mt-3 text-sm font-bold text-foreground-900 group-hover:text-secondary-800 transition-colors">
                  {cat.name}
                </span>
                <span className="mt-1 text-xs text-foreground-500 leading-relaxed line-clamp-2 flex-1">{cat.desc}</span>
                <span className="mt-3 text-xs text-foreground-400 flex items-center gap-1">
                  <i className="ri-folder-open-line" aria-hidden="true" />
                  {count} 条在架
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
    </section>
  );
}